import { Box, Button } from "@mui/material";
import React from "react";

const NotificationButtons = ({ onCategorySelect, selectedButton }) => {
  const categories = [
    { id: 1, name: "Customer Notification", type: "hire" },
    { id: 2, name: "Worker Notification", type: "worker" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        p: 2,
        flexWrap: "wrap",
      }}
    >
      {categories.map((category) => (
        <Box key={category.id}>
          <Button
            onClick={() => onCategorySelect(category)}
            sx={{
              px: 2,
              py: 1,
              fontWeight: "bold",
              fontSize: "12px",
              fontFamily: "Poppins, sans-serif",
              textTransform: "uppercase",
              position: "relative",
              overflow: "hidden",
              border:
                selectedButton === category.id
                  ? "2px solid #800000"
                  : "2px solid #800000",
              color: selectedButton === category.id ? "#FFF" : "#800000",
              background: selectedButton === category.id ? "#800000" : "#FFF",
            }}
          >
            {category.name}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default NotificationButtons;
